export default __webpack_public_path__ + "static/media/Pic10.5236f29c.jpg";